import type { BreadcrumbItem } from './types';
import { Breadcrumbs } from './Breadcrumbs';
import { SidebarTrigger } from '@/components/ui/sidebar';
import { Separator } from '@/components/ui/separator';
import { Icon } from '@/components/ui/icon';
import { ModeIndicator } from './ModeIndicator';
import { SafeModeIndicator } from './SafeModeIndicator';
import { SyncStatusIndicator } from './SyncStatusIndicator';

type HeaderProps = {
  breadcrumbs: BreadcrumbItem[];
  actions?: React.ReactNode;
};

export function Header({ breadcrumbs, actions }: HeaderProps) {
  return (
    <div className="flex w-full items-center gap-2 px-6">
      <SidebarTrigger
        variant="ghost"
        size="icon"
        className="-ml-2 text-text-primary hover:bg-brand-blue-50"
        aria-label="Apri menu"
      >
        <Icon name="panels_top_left" aria-hidden />
      </SidebarTrigger>
      <span className="text-sm font-semibold text-text-primary">LM Sistema Tecnico</span>
      <Separator orientation="vertical" className="mx-1.5 h-4 bg-[var(--border-default)]" />
      <Breadcrumbs items={breadcrumbs} />
      <div className="ml-auto flex items-center gap-2">
        <ModeIndicator />
        <SafeModeIndicator />
        <SyncStatusIndicator />
        {actions}
      </div>
    </div>
  );
}

export type { BreadcrumbItem } from './types';
